// Generated using typescript-generator version null on 2020-08-19 08:54:21.

import {Observable} from 'rxjs/Rx';
import {Injectable} from '@angular/core';
import {Http, RequestOptions} from "@angular/http";


export const UPDATE_PASSWORD_ALERTE_VISIBILITY_KEY = "alerteVisibility";
export const DAYS_BEFORE_EXPIRE_KEY = "daysBeforeExpire";
export const IS_FIRST_CONNECTION_KEY = "firstConnection";
export const MIN_PASSWORD_LENGTH = 12;
export const MAX_PASSWORD_LENGTH = 20;

export class PasswordLevelValue {
    public static FAIBLE: string = 'FAIBLE';
    public static MOYEN: string = 'MOYEN';
    public static FORT: string = 'FORT';
}


export class AuthenticationResponseDto  implements Dto {
    login?: string;
    cookieValue?: string;
}

export class UserInformations {
    id?: string;
    login?: string;
    prenom?: string;
    nom?: string;
    telephone?: string;
    role?: UserRole;
    lang?: Locale;
    origine?: string;
    url?: string;
    codeRpps?: string;
    date?: any;
    expires?: any;
    metadata?: { [index: string]: any };
    modules?: string[];
    correspondants?: Correspondant[];
    properties?: { [index: string]: any };
    profil?: ProfilDto;
    'e-mail'?: string;
    daysBeforeExpire: number | undefined | null;
    firstConnection: boolean | undefined | null;
}

export class TokenDto extends UserInformations implements Dto {
    token?: string;
    cookie?: string;
    maxUse?: number;
    count?: number;
    expireDays?: number;
}

export class TokenResponseDto extends TokenDto {
    tokenCreationDate?: any;
}

export class AuthenticationDto implements Dto {
    login?: string;
    password?: string;
}

export class CampagneDto {
    id?: number;
    libelle?: string;
    active?: boolean;
    dateFin?: Date;
}

export class ParameterDTO {
    stringValue?: string;
}

export class ModuleAuthenticationDto implements Dto {
    moduleId?: string;
    password?: string;
}

export class ModuleAuthenticationResponseDto implements Dto {
    moduleId?: string;
    cookieValue?: string;
}

export class Profil implements LongIdObject {
    id?: number;
    libelle?: string;
    champs?: string[];
}

export class TagSearchCriteria {
    enable?: boolean;
    categorie?: string;
}

export class UserTransformationCompteDto implements Dto {
    profil?: ProfilDto;
    prenom?: string;
    nom?: string;
    email?: string;
    telephone?: string;
    codeRpps?: string;
    hasAcceptEmail?: boolean;
    hasAcceptCGU?: boolean;
}

export class ProfilValideDto implements Dto {
    ko?: boolean;
    dateLimite?: string;
    autoDisplayPopin?: boolean;
}

export class TokenGuestDto implements Dto {
    token?: string;
}

export class CorrespondantDetails {
    code?: string;
    nom?: string;
    service?: string;
    adressePrincipale?: Adresse;
    adresseLivraison?: Adresse;
    telephone?: string;
    fax?: string;
    email?: string;
    numFiness?: string;
    numAdeli?: string;
    codeRpps?: string;
    typeCarte?: string;
    langue?: Locale;
    correspondantParent?: string;
}

export class UserSearchCriteria {
    tags?: string[];
    roles?: UserRole[];
}

export class KeyDto {
    key?: string;
}

export interface Dto {
}

export class Locale {
}

export class Correspondant {
    code?: string;
    nom?: string;
    tags?: string[];
    dateDesactivation?: any;
    metadata?: { [index: string]: any };
}

export class ProfilDto implements Dto {
    id?: number;
    libelle?: string;
    traduction?: string;
    champs?: string[];
}

export class CorrespondantDto implements Dto {
    code: string;
    nom: string;
    tags: string[];
}

export interface LongIdObject {
    id?: number;
}

export class TagDto implements Dto {
    id?: number;
    enabled?: boolean;
    nomtechnique?: string;
    label_en?: string;
    label_fr?: string;
    position?: number;
    categorie?: string;
}

export class Adresse {
    ligne1?: string;
    ligne2?: string;
    ligne3?: string;
    codePostal?: string;
    ville?: string;
    pays?: string;
}

export class UpdatePasswordDto {
    oldPassword: string;
    newPassword: string;
}

export interface Cloneable {
}

export interface Serializable {
}

export abstract class HttpClient {
    abstract request(requestConfig: { method: string; url: string; queryParams?: any; data?: any; }): RestResponse<any>;
}

@Injectable()
export class AuthResourcesClient implements HttpClient {

    constructor(private http: Http) {
    }

    request(requestConfig: { method: string; url: string; queryParams?: any; data?: any; }): RestResponse<any> {
        let requestOptions = new RequestOptions();
        if (requestConfig.queryParams) {
            requestOptions.params = requestConfig.queryParams;
        }
        switch (requestConfig.method) {
            case 'GET': {
                if (requestConfig.queryParams) {
                    return this.http.get(requestConfig.url, requestOptions).map(reponse => reponse.json()).share();
                } else {
                    return this.http.get(requestConfig.url, requestConfig.data).map(reponse => reponse.json()).share();
                }
            }
            case 'POST': {
                return this.http.post(requestConfig.url, requestConfig.data, requestOptions).map(reponse => reponse.json()).share();
            }
            case 'DELETE': {
                if (requestConfig.queryParams) {
                    return this.http.delete(requestConfig.url, requestOptions).map(reponse => reponse.json()).share();
                } else {
                    return this.http.delete(requestConfig.url, requestConfig.data).map(reponse => reponse.json()).share();
                }
            }
            case 'PUT': {
                return this.http.put(requestConfig.url, requestConfig.data, requestOptions).map(reponse => reponse.json()).share();
            }
            default:
                throw "Invalid argument";
        }
    }
}

@Injectable()
export class IAuthenticationPublicWebServiceClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * guest
     * Response code 200 - Connexion de l'utilisateur Guest réalisée avec succès
     * HTTP GET /public/guest
     * Java method: fr.cerba.digicerba.authentification.webservices.IAuthenticationPublicWebService.guest
     */
    guest(queryParams?: { lang?: string; }): RestResponse<AuthenticationResponseDto> {
        return this.httpClient.request({method: 'GET', url: uriEncoding`public/guest`, queryParams: queryParams});
    }

    /**
     * validateToken
     * Response code 200 - Le token est validé
     * HTTP GET /public/token/validate
     * Java method: fr.cerba.digicerba.authentification.webservices.IAuthenticationPublicWebService.validateToken
     */
    validateToken(queryParams?: { token?: string; }): RestResponse<TokenResponseDto> {
        return this.httpClient.request({
            method: 'GET',
            url: uriEncoding`public/token/validate`,
            queryParams: queryParams
        });
    }
}

@Injectable()
export class IAuthenticationWebServiceClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * login
     * Response code 200 - Connexion de l'utilisateur réalisée avec succès
     * HTTP POST /login
     * Java method: fr.cerba.digicerba.authentification.webservices.IAuthenticationWebService.login
     */
    login(arg0: AuthenticationDto): RestResponse<AuthenticationResponseDto> {
        return this.httpClient.request({method: 'POST', url: uriEncoding`login`, data: arg0});
    }

    /**
     * logout
     * Response code 200 - Déconnexion de l'utilisateur réalisée avec succès
     * HTTP POST /logout
     * Java method: fr.cerba.digicerba.authentification.webservices.IAuthenticationWebService.logout
     */
    logout(): RestResponse<void> {
        return this.httpClient.request({method: 'POST', url: uriEncoding`logout`});
    }

    /**
     * reset
     * Response code 200 - Demande de mot de passe réalisée avec succès
     * HTTP POST /reset
     * Java method: fr.cerba.digicerba.authentification.webservices.IAuthenticationWebService.reset
     */
    reset(queryParams?: { login?: string; }): RestResponse<boolean> {
        return this.httpClient.request({method: 'POST', url: uriEncoding`reset`, queryParams: queryParams});
    }
}

@Injectable()
export class ICampagneWebServiceClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * email
     * Response code 200 - Récupération de la campagne réalisée avec succès
     * HTTP GET /campagne/email
     * Java method: fr.cerba.digicerba.authentification.webservices.ICampagneWebService.getEmailCampagne
     */
    getEmailCampagne(): RestResponse<CampagneDto> {
        return this.httpClient.request({method: 'GET', url: uriEncoding`campagne/email`});
    }
}

@Injectable()
export class IParameterWebServiceClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * message
     * Response code 200 - Récupération du message réalisée avec succès
     * HTTP GET /campagne/email
     * Java method: fr.cerba.digicerba.authentification.webservices.ICampagneWebService.getEmailCampagne
     */
    getMessageNotification(): RestResponse<ParameterDTO> {
        return this.httpClient.request({method: 'GET', url: uriEncoding`parameter/message/bandeau`});
    }
}

@Injectable()
export class ICorrespondantWebServiceClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * correspondants/all
     * Response code 200 - Récupération des correspondants réalisée avec succès
     * HTTP GET /correspondants/all
     * Java method: fr.cerba.digicerba.authentification.webservices.ICorrespondantWebService.getAllCorrespondants
     */
    getAllCorrespondants(queryParams?: { enable?: boolean; }): RestResponse<CorrespondantDto[]> {
        return this.httpClient.request({method: 'GET', url: uriEncoding`correspondants/all`, queryParams: queryParams});
    }
}

@Injectable()
export class IModuleWebServiceClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * loginModule
     * Response code 200 - L'authentification du module a été réalisée avec succès
     * HTTP POST /sso/login-module
     * Java method: fr.cerba.digicerba.authentification.webservices.IModuleWebService.loginModule
     */
    loginModule(arg0: ModuleAuthenticationDto): RestResponse<ModuleAuthenticationResponseDto> {
        return this.httpClient.request({method: 'POST', url: uriEncoding`sso/login-module`, data: arg0});
    }
}

@Injectable()
export class IPageTokenWebServiceClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * createToken
     * Response code 200 - Le token de page est créé
     * HTTP POST /page/token/create
     * Java method: fr.cerba.digicerba.authentification.webservices.IPageTokenWebService.createToken
     */
    createToken(arg0: TokenDto): RestResponse<TokenResponseDto> {
        return this.httpClient.request({method: 'POST', url: uriEncoding`page/token/create`, data: arg0});
    }

    /**
     * deleteToken
     * Response code 200 - Le token de page est supprimé
     * HTTP POST /page/token/delete
     * Java method: fr.cerba.digicerba.authentification.webservices.IPageTokenWebService.deleteToken
     */
    deleteToken(arg0: string): RestResponse<void> {
        return this.httpClient.request({method: 'POST', url: uriEncoding`page/token/delete`, data: arg0});
    }

    /**
     * getToken
     * Response code 200 - Le token est retouné
     * HTTP GET /page/token/get
     * Java method: fr.cerba.digicerba.authentification.webservices.IPageTokenWebService.getToken
     */
    getToken(queryParams?: { token?: string; }): RestResponse<TokenResponseDto> {
        return this.httpClient.request({method: 'GET', url: uriEncoding`page/token/get`, queryParams: queryParams});
    }
}

@Injectable()
export class IProfilWebServiceClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * all
     * Response code 200 - Récupération de la liste des profils réalisée avec succès
     * HTTP GET /profil/all
     * Java method: fr.cerba.digicerba.authentification.webservices.IProfilWebService.getAllProfil
     */
    getAllProfil(): RestResponse<ProfilDto[]> {
        return this.httpClient.request({method: 'GET', url: uriEncoding`profil/all`});
    }

    /**
     * user
     * Response code 200 - Récupération du profil réalisée avec succès
     * HTTP GET /profil/user
     * Java method: fr.cerba.digicerba.authentification.webservices.IProfilWebService.getUserProfil
     */
    getUserProfil(): RestResponse<Profil> {
        return this.httpClient.request({method: 'GET', url: uriEncoding`profil/user`});
    }
}

@Injectable()
export class ITagWebServiceClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * all
     * Response code 200 - Récupération de la listes des tags
     * HTTP POST /tags/all
     * Java method: fr.cerba.digicerba.authentification.webservices.ITagWebService.getAllTags
     */
    getAllTags(arg0: TagSearchCriteria): RestResponse<TagDto[]> {
        return this.httpClient.request({method: 'POST', url: uriEncoding`tags/all`, data: arg0});
    }

    /**
     * module
     * HTTP POST /tags/module
     * Java method: fr.cerba.digicerba.authentification.webservices.ITagWebService.getAllTagsForModule
     */
    getAllTagsForModule(arg0: string): RestResponse<TagDto[]> {
        return this.httpClient.request({method: 'POST', url: uriEncoding`tags/module`, data: arg0});
    }
}

@Injectable()
export class IUserTransformationCompteWebServiceClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * current
     * Response code 200 - Récupération des infos de compte réalisée avec succès
     * HTTP GET /usercompte/current
     * Java method: fr.cerba.digicerba.authentification.webservices.IUserTransformationCompteWebService.getUserInformationCompte
     */
    getUserInformationCompte(): RestResponse<UserTransformationCompteDto> {
        return this.httpClient.request({method: 'GET', url: uriEncoding`usercompte/current`});
    }

    /**
     * /
     * Response code 200 - Retourne les infos de validité du comtpe courant avec succès
     * Response code 500 - Erreur interne à la récupération des informations
     * HTTP GET /usercompte/profilValide
     * Java method: fr.cerba.digicerba.authentification.webservices.IUserTransformationCompteWebService.profilValide
     */
    profilValide(): RestResponse<ProfilValideDto> {
        return this.httpClient.request({method: 'GET', url: uriEncoding`usercompte/profilValide`});
    }

    /**
     * save
     * Response code 200 - Récupération des infos de compte réalisée avec succès
     * HTTP POST /usercompte/save
     * Java method: fr.cerba.digicerba.authentification.webservices.IUserTransformationCompteWebService.saveFromUserInformationCompte
     */
    saveFromUserInformationCompte(arg0: UserTransformationCompteDto): RestResponse<void> {
        return this.httpClient.request({method: 'POST', url: uriEncoding`usercompte/save`, data: arg0});
    }
}

@Injectable()
export class IUsurpationWebServiceClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * token/create/guest/{login}
     * Response code 200 - Le token a été créé
     * HTTP GET /sso/token/create/guest/{login}
     * Java method: fr.cerba.digicerba.authentification.webservices.IUsurpationWebService.createTokenGuest
     */
    createTokenGuest(login: string): RestResponse<TokenGuestDto> {
        return this.httpClient.request({method: 'GET', url: uriEncoding`sso/token/create/guest/${login}`});
    }

    /**
     * loginAs
     * Response code 200 - L'usurpation a été mise en place. Retourne la nouvelle valeur de cookie CERBA_AUTHENTIFICATION
     * HTTP GET /sso/login-as/{login}
     * Java method: fr.cerba.digicerba.authentification.webservices.IUsurpationWebService.loginAs
     */
    loginAs(login: string): RestResponse<UserInformations> {
        return this.httpClient.request({method: 'GET', url: uriEncoding`sso/login-as/${login}`});
    }

    /**
     * logoutAs
     * Response code 200 - L'usurpation a été supprimée. Retourne la nouvelle valeur du cookie CERBA_AUTHENTIFICATION
     * HTTP GET /sso/logout-as
     * Java method: fr.cerba.digicerba.authentification.webservices.IUsurpationWebService.logoutAs
     */
    logoutAs(): RestResponse<UserInformations> {
        return this.httpClient.request({method: 'GET', url: uriEncoding`sso/logout-as`});
    }
}

@Injectable()
export class IUtilisateurInsertWebServiceClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * Creation d'un correspondant
     * Response code 200 - Création de l'utilisateur réalisée avec succès
     * HTTP POST /public/dev/create/correspondant
     * Java method: fr.cerba.digicerba.authentification.webservices.IUtilisateurInsertWebService.createCorrespondant
     */
    createCorrespondant(arg0: CorrespondantDetails): RestResponse<void> {
        return this.httpClient.request({method: 'POST', url: uriEncoding`public/dev/create/correspondant`, data: arg0});
    }

    /**
     * Creation d'un utilisateur
     * Response code 200 - Création de l'utilisateur réalisée avec succès
     * HTTP POST /public/dev/create/user
     * Java method: fr.cerba.digicerba.authentification.webservices.IUtilisateurInsertWebService.createUser
     */
    createUser(arg0: UserInformations): RestResponse<void> {
        return this.httpClient.request({method: 'POST', url: uriEncoding`public/dev/create/user`, data: arg0});
    }

    /**
     * Initialisation
     * Response code 200 - Initialisation réalisée avec succès
     * HTTP GET /public/dev/create/init
     * Java method: fr.cerba.digicerba.authentification.webservices.IUtilisateurInsertWebService.init
     */
    init(): RestResponse<void> {
        return this.httpClient.request({method: 'GET', url: uriEncoding`public/dev/create/init`});
    }
}

@Injectable()
export class IUtilisateurWebServiceClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * decrypt
     * Response code 200 - Décryptage du token réussi
     * HTTP POST /decrypt
     * Java method: fr.cerba.digicerba.authentification.webservices.IUtilisateurWebService.decrypt
     */
    decrypt(): RestResponse<UserInformations> {
        return this.httpClient.request({method: 'POST', url: uriEncoding`decrypt`});
    }

    /**
     * getCorrespondantDetails
     * Response code 200 - Récupération du détail d'un correspondant réalisée avec succès
     * HTTP GET /correspondant/{code}
     * Java method: fr.cerba.digicerba.authentification.webservices.IUtilisateurWebService.getCorrespondantDetails
     */
    getCorrespondantDetails(code: string): RestResponse<CorrespondantDetails> {
        return this.httpClient.request({method: 'GET', url: uriEncoding`correspondant/${code}`});
    }

    /**
     * informations
     * Response code 200 - Récupération de l'utilisateur réalisée avec succès
     * HTTP GET /user/{login}
     * Java method: fr.cerba.digicerba.authentification.webservices.IUtilisateurWebService.informations
     */
    informations(login: string): RestResponse<UserInformations> {
        return this.httpClient.request({method: 'GET', url: uriEncoding`user/${login}`});
    }

    /**
     * active
     * Response code 200 - Récupération de l'utilisateur réalisée avec succès
     * HTTP GET /user/{login}/active
     * Java method: fr.cerba.digicerba.authentification.webservices.IUtilisateurWebService.isActive
     */
    isActive(login: string): RestResponse<boolean> {
        return this.httpClient.request({method: 'GET', url: uriEncoding`user/${login}/active`});
    }

    /**
     * getCorrespondantDetails
     * Response code 200 - Récupération des utilisateurs correspondants aux critères réalisée avec succès
     * HTTP POST /user/search
     * Java method: fr.cerba.digicerba.authentification.webservices.IUtilisateurWebService.searchUsers
     */
    searchUsers(arg0: UserSearchCriteria): RestResponse<UserInformations[]> {
        return this.httpClient.request({method: 'POST', url: uriEncoding`user/search`, data: arg0});
    }

    /**
     * user/updateinformations
     * Response code 200 - Mise a jour réussi
     * HTTP POST /user/updateinformations
     * Java method: fr.cerba.digicerba.authentification.webservices.IUtilisateurWebService.updateUserinformations
     */
    updateUserinformations(arg0: UserInformations): RestResponse<void> {
        return this.httpClient.request({method: 'POST', url: uriEncoding`user/updateinformations`, data: arg0});
    }

    /**
     * user/updatepassword
     * Response code 200 - Mise a jour réussi
     * HTTP POST /user/updatepassword
     * Java method: fr.cerba.digicerba.authentification.webservices.IUtilisateurWebService.updatepassword
     */
    updatepassword(arg0: UpdatePasswordDto): RestResponse<boolean> {
        return this.httpClient.request({method: 'POST', url: uriEncoding`user/updatepassword`, data: arg0});
    }
}

@Injectable()
export class ICryptoWebServiceClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * key
     * Response code 200 - Renvoi de la clé publique avec succès
     * Response code 500 - Erreur interne lors de la récupération de la clé privée
     * HTTP GET /sso/crypto/key
     * Java method: fr.cerba.digicerba.security.crypto.server.ICryptoWebService.key
     */
    key(): RestResponse<KeyDto> {
        return this.httpClient.request({method: 'GET', url: uriEncoding`sso/crypto/key`});
    }
}

export type RestResponse<R> = Observable<R>;

export type UserRole =
    'COMPTE_LIE'
    | 'INVITE'
    | 'ANCIEN_COMPTE'
    | 'ADMINISTRATEUR'
    | 'RESPONSABLE'
    | 'MODULE'
    | 'PROSPECT';

function uriEncoding(template: TemplateStringsArray, ...substitutions: any[]): string {
    let result = '/authentification/api/';
    for (let i = 0; i < substitutions.length; i++) {
        result += template[i];
        result += encodeURIComponent(substitutions[i]);
    }
    result += template[template.length - 1];
    return result;
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/resources/auth/resources.auth.ts